import { Grid } from 'swp-components/lib/components/highlight-banner'

const HighlightBanner = ({ columns, banners, ...props }) => {
  banners = banners.slice(0, columns)

  return <Grid columns={columns} banners={banners} {...props} />
}

export default HighlightBanner
